import React from 'react';
import PropTypes from 'prop-types';

import { resolveDefaultSortOrder, sortOptions } from '@components/show_page/sections/view_options/helper';
import Tooltip from '@components/common/tooltip/main';
import { ListDropdown } from '@components/library/dropdown';
import { updateBrandfolderSettings } from '@api/v4/brandfolders';

export default class DefaultSortForm extends React.Component {
  state = {
    selectedSortName: resolveDefaultSortOrder(this.props.sortName)
  };

  updateSortOrder(order) {
    this.setState({ selectedSortName: order });
    updateBrandfolderSettings({
      brandfolderKey: this.props.brandfolderKey,
      defaultOrderMethod: order,
    })
      .then(() => {
        if (BFG.brandfolderSettings.default_order_method) { // not present on org page
          BFG.brandfolderSettings.default_order_method = order;
        }
        Notify.create({
          title: bfTranslate("The default sort order has been updated for all users for this Brandfolder"),
          type: "success"
        });
      })
      .catch(() => {
        this.setState({ selectedSortName: this.props.sortName });
        Notify.create({
          title: bfTranslate("An error occured and the default sort order was not changed. Please try again!"),
          type: "error"
        });
      });
  }

  render() {
    return (
      <div className="default-sort-container">
        <div className="advanced-settings-row">
          <div className="quarter-column default-sort-title">
            <h4>{bfTranslate('Default Sort Option')}</h4>
            <Tooltip
              tooltipId="default-sort-info"
              tooltipContent={bfTranslate("Set the default sort option for all users that visit this Brandfolder or any of its Collections.")}
            >
              <span className="bff-tool-tip" />
            </Tooltip>
          </div>
          <div className="three-quarter-column">
            <ListDropdown
              options={sortOptions()}
              onChange={(option) => this.updateSortOrder(option.value)}
              value={this.state.selectedSortName}
            />
          </div>
        </div>
      </div>
    );
  }
}

DefaultSortForm.propTypes = {
  brandfolderKey: PropTypes.string.isRequired,
  sortName: PropTypes.string.isRequired,
};
